import axios from 'axios';
import { BASE_URL } from '@/config/const';

class StoryAPI {
  async list(payload) {
    return await axios.get(`${BASE_URL}/v2/story/group`, { params: payload });
  }

  async get(payload) {
    return await axios.get(`${BASE_URL}/v2/story/group/${payload.ipId}/${payload.storyGroupId}`);
  }

  async getStoryScenario(payload) {
    return await axios.get(`${BASE_URL}/v2/story/group/${payload.ipId}/${payload.storyGroupId}/view/${payload.storyEpisodeId}`);
  }

  async getIp(id) {
    return await axios.get(`${BASE_URL}/v2/story/ip/${id}`);
  }

  async getIpNoLogin(id) {
    return await axios.get(`${BASE_URL}/v2/story/ip/nologin/${id}`);
  }

  async purchase(payload) {
    const datas = {
      platformType: 'WEB'
    };
    if (payload.needsPurchase) {
      datas.needsPurchase = payload.needsPurchase;
    }
    return await axios.post(`${BASE_URL}/v2/story/group/${payload.ipId}/${payload.story.storyGroupId}/view/${payload.story.storyEpisodeId}`, datas);
  }

  async postIp(payload) {
    const datas = {
      lastName: payload.lastName,
      firstName: payload.firstName
    };
    return await axios.post(`${BASE_URL}/v2/story/ip/${payload.ipId}`, datas);
  }
}

export default new StoryAPI();
